<script>
import { required } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Swal from "sweetalert2";
import General from "@/services/General";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

function createEmptySubItem() {
  return {
    title: "",
    subtitle: "",
    type: "link",
    url: "",
    pdfFile: null,
    pdfFileName: "",
    deepLinkingAction: "",
    deepLinkingFullScreen: "Yes",
    second_level_key: "",
    second_level_title: "",
    secondLevelOptions: [],
    selectedSecondLevel: "",
    showSecondLevel: false,
  };
}

export default {
  components: {
    validationMessages,
    Multiselect,
  },
  validations: {
    title: { required },
  },
  data() {
    return {
      csrf_token: localStorage.getItem("csrf_token"),

      showModal: false,
      tryingToSubmit: false,
      submitted: false,

      linkMode: "standalone",
      selectedType: "link",
      title: "",
      subtitle: "",

      url: "",

      methodOption: [],
      deepLinkActions: [],

      deepLinkingAction: "",
      showSecondLevel: false,
      second_level_key: "",
      second_level_title: "",
      secondLevelOptions: [],
      selectedSecondLevel: "",
      deepLinkingFullScreen: "Yes",

      pdfFile: null,
      pdfFileName: "",

      placementOptions: [],
      selectedPlacements: [],

      subItems: [createEmptySubItem()],

      linkModeOptions: [
        { value: "standalone", text: "Standalone" },
        { value: "group", text: "Group" },
      ],
      typeOptions: [
        { value: "link", text: "link" },
        { value: "deeplink", text: "deeplink" },
        { value: "pdf", text: "pdf" },
      ],
      subItemTypeOptions: [
        { value: "link", text: "link" },
        { value: "deeplink", text: "deeplink" },
        { value: "pdf", text: "pdf" },
      ],
    };
  },

  computed: {
    isGroup() {
      return this.linkMode === "group";
    },
    isStandalone() {
      return this.linkMode === "standalone";
    },
    showLinkFields() {
      return this.isStandalone && this.selectedType === "link";
    },
    showDeeplinkFields() {
      return this.isStandalone && this.selectedType === "deeplink";
    },
    showPdfFields() {
      return this.isStandalone && this.selectedType === "pdf";
    },
  },

  created() {
    this.getDeeplinkCampaignMethods();
  },

  methods: {
    closeModal() {
      this.showModal = false;
      this.resetProps();
    },

    resetProps() {
      this.tryingToSubmit = false;
      this.submitted = false;

      this.linkMode = "standalone";
      this.selectedType = "link";
      this.title = "";
      this.subtitle = "";
      this.url = "";

      this.deepLinkingAction = "";
      this.showSecondLevel = false;
      this.second_level_key = "";
      this.second_level_title = "";
      this.secondLevelOptions = [];
      this.selectedSecondLevel = "";
      this.deepLinkingFullScreen = "Yes";

      this.pdfFile = null;
      this.pdfFileName = "";
      this.selectedPlacements = [];
      this.subItems = [createEmptySubItem()];

      this.$v.$reset();
    },

    refreshScreen() {
      this.$emit("refreshScreen");
    },

    addSubItem() {
      this.subItems.push(createEmptySubItem());
    },

    removeSubItem(index) {
      if (this.subItems.length <= 1) {
        return;
      }
      this.subItems.splice(index, 1);
    },

    async getAvailablePlacements() {
      try {
        const response = await General.getAvailableApplicationLinkPlacements();
        const data = response.data?.data ?? [];
        this.placementOptions = Array.isArray(data) ? data : [];
      } catch (e) {
        this.placementOptions = [];
      }
    },

    async onModalShown() {
      await this.getAvailablePlacements();
    },

    async getDeeplinkCampaignMethods() {
      try {
        const response = await General.getDeeplinkCampaignMethods();
        const data = response.data.data ? response.data.data : [];
        this.methodOption = data;
        this.deepLinkActions = data.map((item) => ({
          action: item.method,
          name: item.description,
        }));
      } catch (e) {
        this.methodOption = [];
        this.deepLinkActions = [];
      }
    },

    getDeeplinkSecondLevel(second_level, target) {
      if (!second_level) {
        target.secondLevelOptions = [];
        target.showSecondLevel = false;
        target.selectedSecondLevel = "";
        return;
      }

      General.getDeeplinkSecondLevelOptions(second_level)
        .then((response) => {
          target.secondLevelOptions = response.data.data ? response.data.data : [];
          target.showSecondLevel = target.secondLevelOptions.length > 0;
        })
        .catch(() => {
          target.secondLevelOptions = [];
          target.showSecondLevel = false;
        });
    },

    onChangeScreen() {
      this.showSecondLevel = false;
      this.secondLevelOptions = [];
      this.selectedSecondLevel = "";

      const selected = this.methodOption.find(
        (m) => m.method === this.deepLinkingAction
      );
      this.second_level_key =
        selected && selected.second_level ? selected.second_level : "";
      this.second_level_title =
        selected && selected.second_level_description
          ? selected.second_level_description
          : "";

      if (this.second_level_key) {
        this.getDeeplinkSecondLevel(this.second_level_key, this);
      }
    },

    onSubItemChangeScreen(subItem) {
      subItem.showSecondLevel = false;
      subItem.secondLevelOptions = [];
      subItem.selectedSecondLevel = "";

      const selected = this.methodOption.find(
        (m) => m.method === subItem.deepLinkingAction
      );
      subItem.second_level_key =
        selected && selected.second_level ? selected.second_level : "";
      subItem.second_level_title =
        selected && selected.second_level_description
          ? selected.second_level_description
          : "";

      if (subItem.second_level_key) {
        this.getDeeplinkSecondLevel(subItem.second_level_key, subItem);
      }
    },

    onPdfSelected(event) {
      const file =
        event.target.files && event.target.files[0]
          ? event.target.files[0]
          : null;
      this.pdfFile = file;
      this.pdfFileName = file ? file.name : "";
    },

    onSubItemPdfSelected(event, subItem) {
      const file =
        event.target.files && event.target.files[0]
          ? event.target.files[0]
          : null;
      subItem.pdfFile = file;
      subItem.pdfFileName = file ? file.name : "";
    },

    buildDeepLinkPayload(action, fullscreen, secondLevelKey, selectedSecondLevel) {
      const deepLink = {
        action: action || "",
        fullscreen: fullscreen || "Yes",
      };
      if (selectedSecondLevel && secondLevelKey) {
        deepLink[secondLevelKey] = selectedSecondLevel;
      }
      return deepLink;
    },

    validateStandalone() {
      if (this.showLinkFields && !this.url) {
        Swal.fire("Missing URL", "Please provide URL.", "warning");
        return false;
      }
      if (this.showPdfFields && !this.pdfFile) {
        Swal.fire("Missing PDF", "Please upload a PDF file.", "warning");
        return false;
      }
      return true;
    },

    validateGroup() {
      if (!this.subItems.length) {
        Swal.fire("Missing sub-items", "Add at least one link to the group.", "warning");
        return false;
      }

      for (let i = 0; i < this.subItems.length; i++) {
        const item = this.subItems[i];
        const label = `Sub-item ${i + 1}`;

        if (!item.title.trim()) {
          Swal.fire("Missing title", `${label}: title is required.`, "warning");
          return false;
        }
        if (item.type === "link" && !item.url.trim()) {
          Swal.fire("Missing URL", `${label}: URL is required.`, "warning");
          return false;
        }
        if (item.type === "pdf" && !item.pdfFile) {
          Swal.fire("Missing PDF", `${label}: PDF file is required.`, "warning");
          return false;
        }
      }

      return true;
    },

    buildStandalonePayload() {
      const payload = {
        title: this.title,
        type: this.selectedType,
        placements: [...this.selectedPlacements],
      };

      if (this.subtitle) {
        payload.subtitle = this.subtitle;
      }
      if (this.showLinkFields) {
        payload.url = this.url;
      }
      if (this.showDeeplinkFields) {
        payload.deep_link = this.buildDeepLinkPayload(
          this.deepLinkingAction,
          this.deepLinkingFullScreen,
          this.second_level_key,
          this.selectedSecondLevel
        );
      }

      const useMultipart = this.showPdfFields && !!this.pdfFile;
      if (useMultipart) {
        const formData = new FormData();
        formData.append("title", payload.title);
        formData.append("type", payload.type);
        formData.append("csrf_token", this.csrf_token);
        payload.placements.forEach((placement) => {
          formData.append("placements[]", placement);
        });
        if (payload.subtitle) {
          formData.append("subtitle", payload.subtitle);
        }
        formData.append("pdf_file", this.pdfFile, this.pdfFileName);
        return { data: formData, isMultipart: true };
      }

      return { data: payload, isMultipart: false };
    },

    buildGroupPayload() {
      const useMultipart = this.subItems.some((item) => item.type === "pdf");

      if (!useMultipart) {
        const payload = {
          title: this.title,
          type: "category",
          placements: [...this.selectedPlacements],
          sub_items: this.subItems.map((item) => {
            const subItem = {
              title: item.title.trim(),
              type: item.type,
            };
            if (item.subtitle) {
              subItem.subtitle = item.subtitle;
            }
            if (item.type === "link") {
              subItem.url = item.url.trim();
            }
            if (item.type === "deeplink") {
              subItem.deep_link = this.buildDeepLinkPayload(
                item.deepLinkingAction,
                item.deepLinkingFullScreen,
                item.second_level_key,
                item.selectedSecondLevel
              );
            }
            return subItem;
          }),
        };
        if (this.subtitle) {
          payload.subtitle = this.subtitle;
        }
        return { data: payload, isMultipart: false };
      }

      const formData = new FormData();
      formData.append("title", this.title);
      formData.append("type", "category");
      formData.append("csrf_token", this.csrf_token);
      if (this.subtitle) {
        formData.append("subtitle", this.subtitle);
      }
      this.selectedPlacements.forEach((placement) => {
        formData.append("placements[]", placement);
      });

      this.subItems.forEach((item, index) => {
        formData.append(`sub_items[${index}][title]`, item.title.trim());
        formData.append(`sub_items[${index}][type]`, item.type);
        if (item.subtitle) {
          formData.append(`sub_items[${index}][subtitle]`, item.subtitle);
        }
        if (item.type === "link") {
          formData.append(`sub_items[${index}][url]`, item.url.trim());
        }
        if (item.type === "deeplink") {
          const deepLink = this.buildDeepLinkPayload(
            item.deepLinkingAction,
            item.deepLinkingFullScreen,
            item.second_level_key,
            item.selectedSecondLevel
          );
          formData.append(
            `sub_items[${index}][deep_link][action]`,
            deepLink.action
          );
          formData.append(
            `sub_items[${index}][deep_link][fullscreen]`,
            deepLink.fullscreen
          );
          Object.keys(deepLink).forEach((key) => {
            if (key !== "action" && key !== "fullscreen") {
              formData.append(
                `sub_items[${index}][deep_link][${key}]`,
                deepLink[key]
              );
            }
          });
        }
        if (item.type === "pdf" && item.pdfFile) {
          formData.append(
            `sub_items[${index}][pdf_file]`,
            item.pdfFile,
            item.pdfFileName
          );
        }
      });

      return { data: formData, isMultipart: true };
    },

    async addApplicationLink() {
      this.tryingToSubmit = true;
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.tryingToSubmit = false;
        return;
      }

      if (!this.selectedPlacements.length) {
        Swal.fire(
          "Missing Placement",
          "Please select at least one placement.",
          "warning"
        );
        this.tryingToSubmit = false;
        return;
      }

      if (this.isStandalone && !this.validateStandalone()) {
        this.tryingToSubmit = false;
        return;
      }

      if (this.isGroup && !this.validateGroup()) {
        this.tryingToSubmit = false;
        return;
      }

      try {
        const { data, isMultipart } = this.isGroup
          ? this.buildGroupPayload()
          : this.buildStandalonePayload();

        const response = await General.createApplicationLink(data, isMultipart);

        if (response.data?.warnings?.length) {
          Swal.fire(
            "Created with warnings",
            response.data.warnings.join("\n"),
            "warning"
          );
        } else {
          Swal.fire(
            "Success",
            this.isGroup ? "Group created!" : "Application link created!",
            "success"
          );
        }

        this.closeModal();
        this.refreshScreen();
      } catch (e) {
        const errorMsg =
          e?.response?.data?.error ||
          e?.response?.data?.message ||
          e?.message ||
          "Failed to create application link.";
        Swal.fire("Error", errorMsg, "error");
      } finally {
        this.tryingToSubmit = false;
      }
    },
  },
};
</script>

<template>
  <b-modal
    id="add_application_link"
    size="lg"
    v-model="showModal"
    title="Add Application Link"
    title-class="font-18"
    body-class="p-3"
    @hidden="resetProps"
    @shown="onModalShown"
  >
    <template v-slot:modal-header>
      <div class="w-100">
        <h5 class="modal-title mb-0">Add Application Link</h5>
      </div>
      <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
    </template>

    <form @submit.prevent="addApplicationLink">
      <div class="card mb-3">
        <div class="card-body py-2">
          <div class="mb-3">
            <b-form-select
              v-model="linkMode"
              :options="linkModeOptions"
            ></b-form-select>
          </div>

          <div class="mb-3">
            <label class="control-label form-label">Title *</label>
            <b-form-input
              v-model.trim="title"
              :class="{ 'is-invalid': submitted && $v.title.$error }"
              :placeholder="isGroup ? 'Group title' : 'Enter title'"
            ></b-form-input>
            <validationMessages
              v-if="submitted"
              :fieldName="'Title'"
              :validationName="$v.title"
            ></validationMessages>
          </div>

          <div class="mb-3">
            <label class="control-label form-label">Subtitle</label>
            <b-form-input v-model.trim="subtitle" placeholder="Enter subtitle"></b-form-input>
          </div>

          <div class="mb-3">
            <label class="control-label form-label">Placement *</label>
            <multiselect
              v-model="selectedPlacements"
              :options="placementOptions"
              :multiple="true"
              :close-on-select="false"
              placeholder="Select placements"
            ></multiselect>
          </div>

          <template v-if="isStandalone">
            <div class="mb-3">
              <label class="control-label form-label">Type</label>
              <b-form-select v-model="selectedType" :options="typeOptions"></b-form-select>
            </div>

            <div v-if="showLinkFields" class="mb-2">
              <label class="control-label form-label">URL</label>
              <b-form-input v-model.trim="url" placeholder="https://example.com"></b-form-input>
            </div>

            <div v-if="showDeeplinkFields" class="mb-2">
              <label class="control-label form-label">Deeplink</label>
              <div class="mb-3">
                <label class="control-label form-label">Screen</label>
                <select
                  v-model="deepLinkingAction"
                  class="form-control form-select"
                  @change="onChangeScreen"
                >
                  <option value="">Home screen</option>
                  <option
                    v-for="screen in deepLinkActions"
                    :key="screen.action"
                    :value="screen.action"
                  >
                    {{ screen.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3" v-if="showSecondLevel">
                <label class="control-label form-label">{{ second_level_title }}</label>
                <select v-model="selectedSecondLevel" class="form-control form-select">
                  <option
                    v-for="option in secondLevelOptions"
                    :key="option.id"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>

            <div v-if="showPdfFields" class="mb-2">
              <label class="control-label form-label">Upload PDF</label>
              <input
                class="form-control"
                type="file"
                accept="application/pdf"
                @change="onPdfSelected"
              />
              <div class="text-muted mt-1" v-if="pdfFileName">
                Selected: {{ pdfFileName }}
              </div>
            </div>
          </template>

          <template v-if="isGroup">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="control-label form-label mb-0">Sub-items *</label>
              <b-button size="sm" variant="outline-primary" @click="addSubItem">
                <i class="mdi mdi-plus"></i> Add link
              </b-button>
            </div>

            <div
              v-for="(subItem, index) in subItems"
              :key="index"
              class="border rounded p-3 mb-3 bg-light"
            >
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="fw-semibold text-muted">Link {{ index + 1 }}</span>
                <b-button
                  v-if="subItems.length > 1"
                  size="sm"
                  variant="outline-danger"
                  @click="removeSubItem(index)"
                >
                  Remove
                </b-button>
              </div>

              <div class="mb-2">
                <label class="control-label form-label">Title *</label>
                <b-form-input
                  v-model.trim="subItem.title"
                  placeholder="Enter title"
                ></b-form-input>
              </div>

              <div class="mb-2">
                <label class="control-label form-label">Subtitle</label>
                <b-form-input
                  v-model.trim="subItem.subtitle"
                  placeholder="Enter subtitle"
                ></b-form-input>
              </div>

              <div class="mb-2">
                <label class="control-label form-label">Type</label>
                <b-form-select
                  v-model="subItem.type"
                  :options="subItemTypeOptions"
                ></b-form-select>
              </div>

              <div v-if="subItem.type === 'link'" class="mb-2">
                <label class="control-label form-label">URL *</label>
                <b-form-input
                  v-model.trim="subItem.url"
                  placeholder="https://example.com"
                ></b-form-input>
              </div>

              <div v-if="subItem.type === 'deeplink'" class="mb-2">
                <label class="control-label form-label">Screen</label>
                <select
                  v-model="subItem.deepLinkingAction"
                  class="form-control form-select"
                  @change="onSubItemChangeScreen(subItem)"
                >
                  <option value="">Home screen</option>
                  <option
                    v-for="screen in deepLinkActions"
                    :key="screen.action"
                    :value="screen.action"
                  >
                    {{ screen.name }}
                  </option>
                </select>

                <div class="mt-2" v-if="subItem.showSecondLevel">
                  <label class="control-label form-label">{{ subItem.second_level_title }}</label>
                  <select v-model="subItem.selectedSecondLevel" class="form-control form-select">
                    <option
                      v-for="option in subItem.secondLevelOptions"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div v-if="subItem.type === 'pdf'" class="mb-2">
                <label class="control-label form-label">Upload PDF *</label>
                <input
                  class="form-control"
                  type="file"
                  accept="application/pdf"
                  @change="onSubItemPdfSelected($event, subItem)"
                />
                <div class="text-muted mt-1" v-if="subItem.pdfFileName">
                  Selected: {{ subItem.pdfFileName }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Cancel</b-button>
      <b-button variant="primary" @click="addApplicationLink" :disabled="tryingToSubmit">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>
